import { InputStateInterface } from 'common/module/input/state.interface';
import { InputValidatorInterface } from 'common/module/input/validator.interface';

export class InputValidatorFileSize implements InputValidatorInterface {
  /**
   * Constructor
   * @param message The error message
   * @param maxFileSize The maximum file size in MB
   */
  constructor(protected message: string, private maxFileSize: number) {}

  /**
   * @inheritDoc
   */
  public getError(value: File, context: { [key: string]: InputStateInterface }): string {
    const sizeInMb = (value?.size || 0) / (1024 * 1024);

    return sizeInMb > this.maxFileSize ? this.message : '';
  }
}
